export function getUserActivity(): number {
  const userActivity = localStorage.getItem('userActivity')
  return userActivity ? Number(userActivity) : Date.now()
}

export function setUserActivity(): void {
  localStorage.setItem('userActivity', Date.now().toString())
}
